import { IconProps } from '.';

const QuillIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142899)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.92183 33.4452C2.92157 33.5188 2.92144 33.5925 2.92144 33.6665L0.431066 33.8213C0.410339 33.6552 0.409977 33.4853 0.422366 33.3187C0.496022 19.4579 4.97466 11.0338 10.8117 6.21991C16.6542 1.40141 23.6734 0.354604 28.4606 0.868419L29.7472 1.0065L29.5648 2.28748C29.1331 5.31895 27.6097 7.83957 25.952 9.76071C24.8519 11.0357 23.6692 12.0744 22.6471 12.8549L24.6222 14.4378L24.0656 15.3725C21.9437 18.9359 19.0181 20.4729 16.2398 21.5091C15.5531 21.7652 14.8684 21.9932 14.2155 22.21L14.1628 22.2275C13.5222 22.4402 12.9149 22.6419 12.3284 22.859C11.122 23.3057 10.0868 23.7891 9.22542 24.4584C7.13449 26.0831 5.49442 28.1775 4.39816 30.0274C3.85133 30.9502 3.45251 31.7908 3.20396 32.4553C3.07941 32.7883 2.99879 33.0605 2.95417 33.2655C2.93705 33.3442 2.92738 33.4033 2.92183 33.4452ZM3.29199 27.1445C4.43095 25.5361 5.90557 23.872 7.6915 22.4843C8.84954 21.5845 10.1618 20.9953 11.4604 20.5145C12.0876 20.2823 12.7309 20.0688 13.3591 19.8602L13.4277 19.8374C14.0847 19.6192 14.7281 19.4046 15.3662 19.1667C17.6053 18.3316 19.6872 17.2417 21.3224 14.9971L18.4316 12.6804L19.8917 11.7401C20.9527 11.0569 22.598 9.82102 24.0592 8.12751C25.2468 6.75125 26.2777 5.11412 26.8069 3.25933C22.6386 3.12875 17.0846 4.28701 12.4023 8.14861C8.12056 11.6799 4.44026 17.5785 3.29199 27.1445Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142899">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuillIcon;
